import { render, staticRenderFns } from "./Hub-Links-Button-Wrapper.vue?vue&type=template&id=03b0d534&"
import script from "./Hub-Links-Button-Wrapper.vue?vue&type=script&lang=js&"
export * from "./Hub-Links-Button-Wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports